import React from 'react';

import { Box, Button, Icon, Text, VStack } from '@betterment/samba-react';

type Props = {
  onRetry: () => void;
};

export const ErrorState: React.FC<Props> = ({ onRetry }) => {
  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        padding: 'space.400',
      }}
    >
      <VStack css={{ gap: 'space.200', alignItems: 'center', maxWidth: '400px' }}>
        <Icon name="ExclamationCircle" size="medium" color="icon" />
        <Text variant="text100" color="text" css={{ textAlign: 'center' }}>
          There was an error generating your personalized account recommendation.
        </Text>
        <Button variant="solidPrimary" onClick={onRetry}>
          Try again
        </Button>
      </VStack>
    </Box>
  );
};
